<template>
  <div>
    <div class="claim-card card">
      <div class="user-name d-flex user p-3">
        <div class="avatar-cont">
          <a-avatar
            @click="routeToProfile()"
            :style="{ color: ' #ffffff !important', 'background-color': info.image ? '' : info.url ? '' : '#C997C5', 'background-color': '#C997C5' }"
            :size="70"
            :src="info.image || info.url"
            class="text-capitalize flex-center-center"
          >
            {{ getInformation("name")[0] }}
          </a-avatar>
          <div class="rating-cont">
            <div class="review-star">
              <ReviewStar :rating="info.rating != undefined ? info.rating.toFixed(2) : 0" />
            </div>
            <span class="rating-text">{{ info.rating != undefined ? info.rating.toFixed(2) : 0 }} stars</span>
            <span class="rating-text">{{ info.review_count }} reviews</span>
          </div>
        </div>
        <hr class="divider" />
        <div class="right-items item">
          <div class="middle-item-cont">
            <div class="title-cont">
              <p class="bold-text cp extra" :style="{ color: '#0F1734', 'font-weight': '700', 'font-size': '20px', 'line-height': '30px', 'margin-bottom': '-3.5px' }" @click="routeToProfile()">
                {{ getInformation("name") }}
              </p>
              <span v-if="getInformation('title')" class="tag" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }">
                {{ getInformation("title") }}
              </span>
            </div>
            <div class="midl-cont">
              <span v-if="info.phone_number" class="text-norm">
                <font-awesome-icon size="1x" :icon="['fal', 'phone-alt']" :style="{ color: '#94A3B8' }" />
                {{ info.phone_number }}
              </span>
              <span v-if="info.address" class="loc-text">
                <font-awesome-icon size="1x" :icon="['fal', 'map-marker-alt']" :style="{ color: '#94A3B8' }" />
                <div class="loc-cont">
                  <span v-if="info.address.city != undefined && info.address.state != undefined" class="loc-text">{{ info.address.city }}, {{ info.address.state }}</span>
                  <span v-if="info.address.street != undefined" class="loc-text">
                    {{ info.address.street.slice(0, 10) }}
                    {{ info.address.street.length > 10 ? "..." : "" }}
                  </span>
                </div>
              </span>
              <span v-else-if="info.location && info.location.length" class="loc-text">
                <font-awesome-icon size="1x" :icon="['fal', 'map-marker-alt']" :style="{ color: '#94A3B8' }" />
                <div class="loc-cont">
                  <span v-if="info.location[0].city && info.location[0].state" class="loc-text">{{ info.location[0].city }}, {{ info.location[0].state }}</span>
                  <span v-if="info.location[0].address_line1" class="loc-text">
                    {{ info.location[0].address_line1.slice(0, 10) }}
                    {{ info.location[0].address_line1.length > 10 ? "..." : "" }}
                  </span>
                </div>
              </span>
              <span class="text-norm2"> 0 miles away </span>
            </div>
          </div>
          <div class="meet-others">
            <a-button
              :style="{ background: getPrimaryColor(), 'pointer-events': 'all', 'font-size': '14px', 'border-radius': '6px', padding: '12px 24px' }"
              class="font-white primary-button"
              :loading="isPageRouting"
              @click="routeToProfile()"
            >
              View Profile
            </a-button>
          </div>
        </div>
      </div>
    </div>
    <RecommendDoctorModal ref="recommendDoctorModal" :fetchUser="fetchCircleProviders" />
  </div>
</template>

<script>
import RecommendDoctorModal from "../../Modals/RecommendDoctor"
import UserRepository from "../../../repositories/userRepository.js"
import ReviewStar from "../../commons/ReviewStar.vue"

const svg1 = require("../../../assets/icon-check-badge.svg")
const svg2 = require("../../../assets/icon-uncheck-badge.svg")

export default {
  name: "SelfProviderCard",
  components: { RecommendDoctorModal, ReviewStar },
  data() {
    return {
      isPageRouting: false,
      activeIcon: null,
      addCircleButtonText: this.isSelf ? "In your circle" : "ADD TO CIRCLE",
      showReview: this.type === "nfp" ? false : true,
      defaultHospitalImage: "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/Hospital.svg",
      defaultClinicImage: "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/Clinic.svg",
      defaultNfpImage: "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/nfp-icon.svg",
    }
  },
  methods: {
    openReviewModal(info) {
      //this.$refs.recommendDoctorModal.show({ ...info, role: this.type === "hcps" ? "hcp" : this.type });
      switch (this.type) {
        case "hcps":
          this.$refs.recommendDoctorModal.show({ ...info, role: "hcp" })
          break
        case "providers":
          this.$refs.recommendDoctorModal.show({ ...info, role: "doctor" })
          break
        case "doctor":
          this.$refs.recommendDoctorModal.show({ ...info, role: "doctor", id: this.affiliatedId })
          break
        default: {
          this.$refs.recommendDoctorModal.show({ ...info, role: this.type })
        }
      }
    },
    addVirtualDocToCircle(info) {
      const id = info.id ? info.id : this.affiliatedId ? this.affiliatedId : this.$route.params.id
      UserRepository.addUserByTypeToCircle(id, this.currentCircle.id, this.type)
        .then(res => {
          this.$notification.success({ message: "Success", description: res.data.message })
          this.addCircleButtonText = "In your circle"
        })
        .catch(err => {
          this.$notification.info({ message: "Information", description: err.response.data.message })
          if (err.response.data.message == "already added") {
            this.addCircleButtonText = "In your circle"
          }
          //this.addCircleButtonText = "ADD TO CIRCLE";
        })
      //this.$emit("addVirtualDocToCircle", info);
    },
    routeToProfile() {
      this.isPageRouting = true
      console.log("info:", this.info)
      // another way -> check if info.user is there, if yes, call normal profile with id:info.user
      switch (this.type) {
        case "physician":
        case "doctor":
        case "providers":
          this.info.is_virtual ? this.viewEntityProfile({ ...this.info, role: "doctor" }) : this.viewProfile({ ...this.info, role: "doctor", id: this.info.id, ext_ref_id: null })
          // this.info.ext_ref_id ? this.viewEntityProfile({ ...this.info, role: "doctor" }) : this.viewProfile({ ...this.info, role: "doctor", id: this.info.id })
          break
        case "other":
        case "hcps":
        case "hcp":
          this.info.is_virtual ? this.viewEntityProfile({ ...this.info, role: "hcp" }) : this.viewProfile({ ...this.info, role: "hcp", id: this.info.id, ext_ref_id: null })
          // this.viewEntityProfile({ ...this.info, role: "hcp" })
          break
        case "hospital":
        case "hospital_administrator":
          this.info.is_virtual ? this.viewEntityProfile({ ...this.info, role: "hospital" }) : this.viewProfile({ ...this.info, role: "hospital_administrator", id: this.info.id, ext_ref_id: null })
          break
        case "clinic":
        case "clinic_administrator":
          this.info.is_virtual ? this.viewEntityProfile({ ...this.info, role: "clinic" }) : this.viewProfile({ ...this.info, role: "clinic_administrator", id: this.info.id, ext_ref_id: null })
          break
        case "nfp":
        case "nfp_administrator":
          this.info.is_virtual ? this.viewEntityProfile({ ...this.info, role: "nfp" }) : this.viewProfile({ ...this.info, role: "nfp_administrator", id: this.info.id, ext_ref_id: null })
          break
      }
    },
    getInformation(value) {
      switch (this.type) {
        case "physician":
        case "doctor":
        case "other":
        case "hcps":
        case "hcp":
          switch (value) {
            case "name":
              return this.info.display_name || this.info.full_name || `Dr. ${this.info.first_name} ${this.info.last_name}${this.info.title ? ", " + this.info.title : ""}`
            case "title":
              return `${this.info.speciality || this.info.physician_speciality || ""}`
            default:
              return ""
          }
          break

        case "hospital":
        case "hospital_administrator": {
          switch (value) {
            case "name":
              return this.info.hospital_name || this.info.display_name || "D"
            case "title":
              return this.info.hospital_type || this.info.speciality || ""
            default:
              return ""
          }
        }
        case "clinic":
        case "clinic_administrator": {
          switch (value) {
            case "name":
              return this.info.clinic_name || this.info.display_name || "D"
            case "title":
              return this.info.clinic_type || this.info.speciality || ""
            default:
              return ""
          }
        }

        case "nfp":
        case "nfp_administrator": {
          switch (value) {
            case "name":
              return this.info.nfp_name || this.info.display_name || "D"
            case "title":
              return this.info.nfp_type || this.info.speciality || ""
            default:
              return ""
          }
        }

        default:
          switch (value) {
            case "name":
              return this.info.display_name || `${this.info.first_name} ${this.info.last_name}${this.info.title ? `, ${this.info.title || ""}` : ""}`
            case "title":
              return `${this.info.speciality || this.info.physician_speciality || ""}`
            default:
              return ""
          }
      }
    },
  },

  props: {
    info: Object,
    type: String,
    hideBtn: Boolean,
    isSelf: Boolean,
    affiliatedId: Number,
    fetchCircleProviders: Function,
  },

  created() {
    console.warn("selfProfiderCard.vue is created ->", this.type)
    // console.log(this.info.display_name, "-> info:", this.info)
    this.activeIcon = this.info.is_verified ? svg1 : svg2
  },
}
</script>

<style lang="scss" scoped>
.user {
  @media screen and (max-width: 700px) {
    height: 100% !important;
  }
}
.card {
  margin-bottom: 16px;
  border: 1px solid #e2e8f0 !important;
}
.loc-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.divider {
  margin-left: 24px;
  margin-top: -24px;
  margin-bottom: -24px;
  border: 1px solid #cbd5e1;
  height: auto;
  // height: 177px;
  background-color: #cbd5e1;
  margin-right: 0px;
  @media screen and (max-width: 600px) {
    height: 100%;
    position: absolute;
    margin-top: -16px;
    margin-left: 107px;
  }
}
.meet-others {
  display: flex;
  align-items: center;
  margin-left: 24px;
  @media screen and (max-width: 700px) {
    // margin-top: 70px;
    margin-left: 0px;
  }
  button {
    display: flex;
    margin-right: 24px;
    font-size: 14px;
    border-radius: 6px;
    padding: 12px 24px;
    width: 126px;
    height: 48px;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    margin-right: 12px;
    @media screen and (max-width: 700px) {
      margin-left: 15.5px;
      justify-content: center;
      width: 100%;
    }
  }
  span {
    font-size: 14px !important;
  }
}
.title-cont {
  margin-left: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 17px;
  width: 213.5px;
  @media screen and (max-width: 600px) {
    width: 100%;
    margin-left: 15.5px;
    gap: 8px;
  }
}

.extra {
  max-width: 213.5px;
  @media screen and (max-width: 600px) {
    max-width: 174px;
  }
}
.middle-item-cont {
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 451px;
  // height: 111px;
  @media screen and (max-width: 600px) {
    flex-direction: column;
    width: 100%;
    gap: 16px;
    margin-top: 0px;
  }
}

.item {
  display: flex;
  @media screen and (max-width: 600px) {
    flex-direction: column;
    width: 100%;
    height: 100%;
    gap: 16px;
    margin-left: 16px;
    padding: 2px;
  }
}
.text-norm2 {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
  margin-left: 18px;
}
.text-norm {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
  gap: 8px;
}

.loc-text {
  gap: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
  display: flex;
  align-items: center;
}
.midl-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  width: 213.5px;
  // min-height: 111px;
  // margin-left: 110.5px;
  @media screen and (max-width: 600px) {
    width: 100%;
    margin-left: 15.5px;
    gap: 8px;
  }
}
.rating-text {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  /* or 117% */

  text-align: center;

  /* Gray/900 */

  color: #0f1734;
}
.rating-cont {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 4px;
  width: 88.53px;
  height: 48px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}
.avatar-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  margin-left: 9.5px;
  width: 93px;
  height: 126px;
  @media screen and (max-width: 600px) {
    margin-left: 0px;
    height: 100%;
    margin-top: 8px;
  }
}

.tag {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 8px;
  // max-width: 174px;
  background: #e1eaf7;
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #2a71d4;
}

.con {
  margin-bottom: 16px;
}
.loc-cont {
  display: flex;
  padding: 0px;
  gap: 4px;
  // min-width: 152px;
  // min-height: 42px;
}
.number {
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
}
.info-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  min-width: 213.5px;
  min-height: 111px;
}

.review-text {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  /* or 117% */

  text-align: center;

  /* Gray/900 */

  color: #0f1734;
}
.cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;

  width: 93px;
  height: 126px;
}
.prov-name {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 8px;
  min-width: 112px;
  height: 22px;
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
}
.card-container {
  border: 1px solid rgba(15, 116, 189, 0.3);
  border-radius: 6px;
  background-color: #ffffff;
  transition: 0.3s all linear;
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;

  &:hover {
    border: 1px solid #a3cce6;
    background-color: #eff5fb;
    transform: scale(1.023);
  }
  .item-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 22px 16px;
    .user-img {
      height: 73px;
      width: 73px;
      cursor: pointer;
      border-radius: 50%;
      border: 1px solid #ccc;
      background-position: center !important;
      background-size: cover !important;
      background-repeat: no-repeat !important;
    }
    .rating {
      margin-top: 6px;
      padding: 1px 5px;
      border-radius: 10px;
      background-color: #f5b255;
      color: #ffffff;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
    }
    .review {
      font-family: Lato;
      font-size: 8px;
      font-weight: bold;
      text-align: center;
      margin-top: 4px;
    }
  }
  .item-right {
    overflow: auto;
    flex: 1;
    padding: 22px 16px;

    .promoted-label {
      border-radius: 7px;
      background-color: rgba(247, 181, 0, 0.25);
      color: #f98e46 !important;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
      align-self: center;
      text-align: center;
      padding: 4px 10px;
      width: 89px;
      margin: 0;
      text-transform: uppercase;
      margin-bottom: 10px;
    }
    .provider-name {
      color: #333333;
      font-family: Lato;
      font-size: 20px;
      cursor: pointer;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .provider-title {
      color: rgba(51, 51, 51, 0.87) !important;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
    }
    .provider-desc {
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
      color: #0f74bd;
    }
    .tags {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 12px -5px 0 -5px;

      @media screen and (max-width: 900px) {
        margin-bottom: 5px;
      }

      .crown {
        border-radius: 7px;
        background-color: rgba(247, 181, 0, 0.25);
        color: #f98e46;
        font-family: Lato;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        margin: 0px 5px;
        padding: 4px 10px;
      }
      .tag {
        border-radius: 7px;
        background-color: rgba(245, 178, 85, 0.25);
        color: #f98e46;
        font-family: Lato;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        margin: 0px 5px;
        padding: 4px 10px;
      }
    }
    .btn-container1 {
      @media (min-width: 768px) {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        margin-left: 15px;
      }
      .btn-primary1 {
        border-radius: 17.5px;
        background-color: #f5b255;
        color: #ffffff;
        font-family: Lato;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 10px;
        padding: 5px 6px;
        max-width: 126px;
        min-width: 99px;

        @media screen and (max-width: 900px) {
          padding: 7px 5px;
        }
      }
      .btn-secondary1 {
        border-radius: 17.5px;
        color: #f5b255;
        margin-top: 10px;
        background: #fff;
        font-family: Lato;
        font-size: 12px;
        padding: 5px 6px;
        font-weight: bold;
        text-align: center;
        max-width: 126px;
        min-width: 99px;
      }
    }
    .contact-number {
      color: #333333;
      font-family: Lato;
      font-size: 16px;
      font-weight: bold;
    }
    .address {
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: #94a3b8;
    }
    .distance {
      color: #333333;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
      margin-left: 15px;
    }
  }
}
@media screen and (max-width: 581px) {
  .card-container .item-right .provider-name {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/provider/selfProfiderCard.vue